import { ColumnsProps } from 'components/Table/Table'
import { getLineTypeByTheme, LINE_TYPES } from 'config/theme.config'
import i18n from 'i18n'

export const allColumns = (): ColumnsProps[] => [
  {
    align: 'right',
    fixed: true,
    name: 'order',
    title: i18n.t('tables:orderNumber')
  },
  {
    align: 'right',
    fixed: true,
    name: 'cargo',
    title: i18n.t('tables:charge')
  },
  {
    align: 'right',
    fixed: true,
    name: 'boughtat',
    title: i18n.t('tables:purchaseDate')
  },
  {
    align: 'right',
    name: 'slaughtedat',
    title: i18n.t('tables:slaughterDate')
  },
  {
    align: 'right',
    name: 'slaughterindustrycnpj',
    title: i18n.t('tables:CNPJIndustrySlaughter')
  },
  {
    align: 'right',
    name: 'producerdoc',
    title: i18n.t('tables:producerDocument')
  },
  {
    align: 'right',
    name: 'producerie',
    title: i18n.t('tables:IE')
  },
  {
    name: 'producername',
    title: i18n.t('common:productor')
  },
  {
    name: 'propname',
    title: i18n.t('tables:corporateNameOwnership')
  },
  {
    align: 'right',
    name: 'propcar',
    title: i18n.t('tables:carNumber')
  },
  {
    align: 'right',
    name: 'proplat',
    title: i18n.t('common:latitude')
  },
  {
    align: 'right',
    name: 'proplng',
    title: i18n.t('common:longitude')
  },
  {
    name: 'propcidade',
    title: i18n.t('common:city')
  },
  {
    name: 'propestado',
    title: i18n.t('common:state')
  },
  {
    align: 'center',
    fixed: false,
    name: 'flagCfv',
    title: i18n.t('common:cfv')
  },
  {
    align: 'center',
    fixed: false,
    name: 'analyze',
    title: i18n.t('common:analyze')
  }
]

export const columnsCertificate = (): ColumnsProps[] => [
  {
    align: 'center',
    fixed: true,
    name: 'name',
    title: 'Nome do protocolo'
  },
  {
    align: 'center',
    fixed: true,
    name: 'number',
    title: 'Número do certificado'
  }
]

const INNATURA_COLUMNS = [
  'order',
  'cargo',
  'boughtat',
  'slaughterindustrycnpj',
  'producerdoc',
  'producerie',
  'producername',
  'propname',
  'propcar',
  'proplat',
  'proplng',
  'propcidade',
  'propestado',
  'flagCfv',
  'analyze'
]

const PROCESSADOS_COLUMNS = [...INNATURA_COLUMNS]

const DISTRIBUTION_COLUMNS = [
  'order',
  'propcar',
  'dt_abate',
  'producerdoc',
  'propname',
  'propcidade',
  'propestado',
  'proplat',
  'proplng',
  'analyze'
]

/**
 * Get columns filtered by business type
 * @param type - Type of columns to return (INNATURA, PROCESSADOS, DISTRIBUTION)
 * @param theme - Current theme (optional, used for conditional filtering)
 * @returns Filtered column list
 */
export const getColumnsByTheme = (theme: string): ColumnsProps[] => {
  const allColumnsList = allColumns()

  const type = getLineTypeByTheme(theme)

  let columnNames: string[] = []

  switch (type) {
    case LINE_TYPES.INNATURA:
      columnNames = INNATURA_COLUMNS
      break
    case LINE_TYPES.PROCESSED:
      columnNames = PROCESSADOS_COLUMNS
      break
    case LINE_TYPES.DISTRIBUTION:
      columnNames = DISTRIBUTION_COLUMNS
      break
    default:
      return allColumnsList
  }

  return columnNames
    .map(name => allColumnsList.find(col => col.name === name))
    .filter(Boolean) as ColumnsProps[]
}

export const columns = (): ColumnsProps[] =>
  getColumnsByTheme(LINE_TYPES.INNATURA)
